import { render, staticRenderFns } from "./LinkElement.vue?vue&type=template&id=549857aa&scoped=true"
import script from "./LinkElement.vue?vue&type=script&lang=js"
export * from "./LinkElement.vue?vue&type=script&lang=js"
import style0 from "./LinkElement.vue?vue&type=style&index=0&id=549857aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549857aa",
  null
  
)

export default component.exports